/**
 * @author wql
 * @description  路径详情页
 * @Date  2020/7/17
 */
import React from "react";
import {connect} from "dva";

import {component_tool, framework_tool, utils_tool} from '../../../../tool';
import {WizAuthority} from "../../../common";
import { formatAuth } from '@/utils/commonUtils'
import {message} from "antd";


let {WizContainer, modelUtils, WizAvatarUpload, ossFileUtils} = framework_tool;
let {WizCard, WizForm, WizSpin, WizInput,Wizmessage} = component_tool;
let {Session} = utils_tool

const validatorTargetScope = (rule, value, callback) => {
  if (value) {
    if (value.groupId) {
      callback()
      return
    }
    if (value.orgIds && value.orgIds.length) {
      callback()
      return
    }
    if (value.positionIds && value.positionIds.length) {
      callback()
      return
    }
    if (value.positionCategoryIds && value.positionCategoryIds.length) {
      callback()
      return
    }
    if (value.personIds && value.personIds.length) {
      callback()
      return
    }
  }
  callback('请选择必修范围')
}

class TrainPathDetail extends WizContainer {
  componentName = 'trainPathDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/trainPath/trainPathUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('trainPathUpd', initialValue)
      } else {
        initialValue = Session.get('trainPathUpd') || {};
      }
      cardTitle = '编辑'
    }
    this.state = {
      cardTitle: cardTitle
    }
    this.initialValue = initialValue;
    this.clearWizCallBack = [];
  }


  propsAndStateOnChange = {
    saveTrainPath: this._saveOver.bind(this)
  }


  _saveOver(nextProps, nextState) {
    if (nextProps.saveTrainPath.success) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/trainPath');
    } else {
      wizNotice.error('提交失败：' + nextProps.msg);
    }
    return true;
  }


  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'fileId' && value != null && value != undefined) {
        if (value && value instanceof Array && value.length > 0) {
          fitterValues[key] = value[0].fileId;
        }
      } else if (key === 'requiredTargetScope' && value != null && value != undefined) {
        /**
         * 必填权限参数处理
         */
        // let requiredTargetScope = {}
        // requiredTargetScope.isAll = value.isAll
        // requiredTargetScope.orgIds = value.orgIds && value.orgIds.map(p => (p.id))
        // requiredTargetScope.positionIds = value.positionIds && value.positionIds.map(p => (p.id))
        // requiredTargetScope.positionCategoryIds = value.positionCategoryIds && value.positionCategoryIds.map(p => (p.id))
        // requiredTargetScope.personIds = value.personIds && value.personIds.map(p => (p['id']))
        // fitterValues[key] = requiredTargetScope;

        fitterValues[key] = formatAuth(value)
      } else if (key === 'electiveTargetScope') {
        /**
         * 选填权限参数处理
         */
        // let electiveTargetScope = {}
        // if (value != null && value != undefined){
        //   electiveTargetScope.isAll = value.isAll
        //   electiveTargetScope.orgIds = value.orgIds && value.orgIds.map(p => (p.id))
        //   electiveTargetScope.positionIds = value.positionIds && value.positionIds.map(p => (p.id))
        //   electiveTargetScope.positionCategoryIds = value.positionCategoryIds && value.positionCategoryIds.map(p => (p.id))
        //   electiveTargetScope.personIds = value.personIds && value.personIds.map(p => (p['id']))
        // }
        // fitterValues[key] = electiveTargetScope;

        fitterValues[key] = formatAuth(value)
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  /**
   * 保存/更新
   * @param values
   * @private
   */
  _save(values) {
    const {history} = this.props;
    let apiPath = "trainPath/add";
    if (this.initialValue.id) {
      apiPath = "trainPath/upd"
    }
    let fitterValues = this.fitterFieldsValue(values);
    this.doAction({
      path: apiPath,
      payload: {
        key: 'saveTrainPath',
        apiParams: {
          ...fitterValues
        }
      }
    });
  }

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  _render() {
    const {trainPathLoading} = this.props;
    let {cardTitle} = this.state;

    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: this.initialValue && this.initialValue.id
        },
        name: "id"
      },
      {
        title: "名称",
        name: "name",
        formItem: {
          maxlength: 30,
          // placeholder: '路径名称最多输入30个字',
          rules: [{
            required: true,
            message: '请输入',
          }],
          initialValue: this.initialValue && this.initialValue.name
        },
      },
      {
        title: "必修范围",
        name: "requiredTargetScope",
        formItem: {
          type: 'diy',
          diy: WizAuthority,
          showBlock: false,
          initialValue: this.initialValue && this.initialValue.requiredTargetScope,
          record: {
            requiredTargetScope: this.initialValue && this.initialValue.requiredTargetScope,
          },
          keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds'],
          rules: [{
            required: true,
            validator: validatorTargetScope
          }],
        },
        onClearWiz: this._onClearWiz.bind(this)
      },
      {
        title: "选修范围",
        name: "electiveTargetScope",
        formItem: {
          type: 'diy',
          diy: WizAuthority,
          showBlock: false,
          initialValue: this.initialValue && this.initialValue.electiveTargetScope,
          record: {
            electiveTargetScope: this.initialValue && this.initialValue.electiveTargetScope,
          },
          keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds']
        },
        onClearWiz: this._onClearWiz.bind(this)
      },
      {
        title: "上传封面",
        name: "fileId",
        dataIndex: "fileId",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            record = this.initialValue//initialValue;
            const {getFieldDecorator} = form;
            let imgOne = null;
            let fileName = null;
            let fileMimeType = null;
            let fileSize = null;
            let fileUri = null;
            if (record != null && record.fileId != null) {
              imgOne = record.fileId;
              fileName = record.fileName;
              fileMimeType = record.fileMimeType;
              fileSize = record.fileSize;
              fileUri = record.fileUri;
            }
            return (
              <div>
                {
                  getFieldDecorator('fileId', {
                    initialValue:
                      (record && record.fileId) ? [
                        {fileId:imgOne}
                      ] : []
                    // , rules: [{
                    //   required: true,
                    //   message: '请上传封面',
                    // }]
                  })(
                    <WizAvatarUpload
                      accept={'.jpg, .jpeg, .png'}
                      listType={'picture-card'}
                      aspectRatio={400 / 207}
                      beforeUpload={(file) => {
                        let result = true;
                        const isLt1M = file.size / 1024 / 1024 < 2;
                        if (file.type.indexOf('image/') == -1) {
                          Wizmessage.error('只能上传图片类型,请重新选择!');
                          result = false;
                        } else if (!isLt1M) {
                          Wizmessage.error('图片不得超过2M!');
                          result = false;
                        }
                        return result;
                      }}
                    />
                  )
                }
              </div>)
          }
        }
      },
      {
        title: "备注",
        name: "briefIntroduction",
        formItem: {
          type: 'textarea',
          rows: 4,
          placeholder: '请输入备注,最多300字',
          maxlength: 300,
          rules: [],
          initialValue: this.initialValue && this.initialValue.briefIntroduction
        }
      }
    ]


    let onSubmit = this._save.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }
    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={trainPathLoading}>
          <WizForm key='trainPathForm' className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {trainPath} = state;
  const saveTrainPath = modelUtils.getModelEntity(trainPath, "saveTrainPath");
  const load = modelUtils.getLoadingState(state, ['trainPath']);
  return {
    saveTrainPath,
    ...load
  }
};

export default connect(mapStateToProps)(TrainPathDetail);
